<div class="flex flex-col gap-2 mb-4">
  <div class="pb-2">
    <div class="flex flex-wrap items-start justify-between gap-3">
      <div class="flex flex-col gap-1">
        <h1 class="text-lg font-bold">Role Bundles</h1>
        <p class="text-sm text-gray-700">
          Reusable sets of roles you can assign to members. Editing a bundle does not change the roles of members who
          already have it until you apply it to them.
        </p>
      </div>

      <button vs-button theme="primary" (click)="create()">
        <vs-icon name="plus"></vs-icon>
        New Bundle
      </button>
    </div>

    <vs-divider class="my-4"></vs-divider>

    <div class="flex justify-between gap-4 mb-4">
      <vs-select
        vsInput
        class="min-w-[180px] max-w-[180px]"
        [value]="statusFilter"
        [config]="{ placeholder: 'All statuses' }"
        (valueChanges)="filterByStatus($any($event))"
      >
        <li *ngFor="let status of statuses" vs-select-option [value]="status.value">{{ status.label }}</li>
      </vs-select>

      <vs-input-container class="max-w-[256px]">
        <vs-icon name="search-lg" slot="start"></vs-icon>
        <input vsInput [formControl]="searchControl" placeholder="Search bundles" />
      </vs-input-container>
    </div>

    <div
      *vsLet="bundles$ | async as bundles"
      class="rounded-xl overflow-hidden border border-gray-200 shadow-sm transition-opacity"
      [class.opacity-60]="loading$ | async"
    >
      <vs-table [columns]="tableColumns" [data]="bundles" (sortChanged)="onSortChanged($event)"></vs-table>

      <p *ngIf="!bundles?.length && (loading$ | async) === false" class="px-4 py-6 text-sm text-center text-gray-500">
        No bundles match your filters.
      </p>

      <vs-pagination [config]="paginationConfig$ | async" (pagination)="onPaginationChanged($event)"></vs-pagination>
    </div>
  </div>
</div>

<ws-role-bundle-dialog (saved)="refresh()"></ws-role-bundle-dialog>
<ws-apply-bundle-dialog (applied)="refresh()"></ws-apply-bundle-dialog>
